<template>
  <div id="dvBubl" v-show="show">
    <p>{{ upravenaHlaska }}</p>
  </div>
</template>

<script>
import sprintf from "locutus/php/strings/sprintf";
import ls from "local-storage";

//--darek v bubline aj
/*
window.Ladzo = {
  darek: {
   zobraz:true,
    test:true,
    hl: "nakupte za  %s a získejte dárek",
    hl_jeste: "nakupte ještě za  %s a získejte dárek",
    hl_ok: "máte nárok na dárek",
    min:{
      czk:650,
      eur:250
    }
  }
};
*/

export default {
  name: "Bublina",
  data: function() {
    return {
      show: true,
      message: "",
      mena: "eur",
      sumaKosiku: 0
    };
  },
  computed: {
    upravenaHlaska: function() {
      let D = fce.get(window.Ladzo, "darek") || false;
      Lc.log("this", this.mena);
      Lc.log("this", this.sumaKosiku);

      let castka = D.min[this.mena];
      Lc.log("castka", castka);
      let rozdil = castka - this.sumaKosiku;
      if (!this.sumaKosiku) {
        let vysl = "€" + rozdil;
        if (this.mena == "czk") vysl = rozdil + " Kč";
        return sprintf(D.hl, vysl);
      } else if (rozdil > 0) {
        //let vysl = "€" + Math.round(rozdil * 100) / 100;
        let vysl = "€" + Math.round(rozdil);
        if (this.mena == "czk") vysl = rozdil + " Kč";
        return sprintf(D.hl_jeste, vysl);
      } else {
        return D.hl_ok;
      }
    }
  },

  mounted() {
    this.upravHlasku();
  },
  methods: {
    upravHlasku: function() {
      Lc.f("uprav hlasku");

      let D = fce.get(window.Ladzo, "darek") || false;
      if (!D || !D.zobraz) {
        this.show = false;
        return false;
      }

      //--pro testovaní, než bude oficialne spušteno
      if (D.test) {
        let test = ls.get("testDarku");
        if (!test) {
          this.show = false;
          return false;
        }
        /*
        let urlP = new URL(window.location.href);
        if (!urlP.searchParams.has("test")) {
          this.show = false;
          return false;
        }
        */
      }

      this.sumaKosiku = this.kosVratSumu();
      let dl = fce.get(window.dataLayer, "0.shoptet") || false;
      if (dl.currency == "CZK") this.mena = "czk";
    },

    kosVratSumu: function() {
      var c = fce.get(window.dataLayer, "0.shoptet.cart") || false;
      if (!c || !c.length) return 0;

      let suma = 0;
      c.forEach(function(entry) {
        suma += entry.quantity * entry.priceWithVat;
      });

      return suma;
    }
  }
};
</script>

<style lang="less">
@clr_zluta: #f0b820;
#dvBubl {
  //display: none;
  margin-top: 20px;
  @media (min-width: 768px) {
    position: absolute;
    right: -20px;
    top: 80px;
    z-index: 5;
  }

  p {
    //width: 300px;
    //min-width: 350px;
    background: white;
    border: @clr_zluta solid 1px;
    border-radius: 10px;
    padding: 5px 10px;
    //display: inline-block;
    white-space: nowrap;
    color: darken(@clr_zluta, 20%);
    box-shadow: 0px 0px 6px 0px rgba(240, 184, 32, 1);
    @media (max-width: 767px) {
      padding: 10px;
      text-align: center;
    }
  }
}
</style>
